window.allowGokwikDrawerOpen = false;

(function () {
  let attempts = 0;

  const interval = setInterval(() => {
    attempts++;

    const fnExists = typeof window.openGokwikSideCart === 'function';
    let sdkReady = false;

    try {
      sdkReady = window.gokwik && typeof window.gokwik.isInitialized === 'function'
        ? window.gokwik.isInitialized()
        : false;
    } catch (e) {
      sdkReady = false;
    }

    if (fnExists && sdkReady) {
      clearInterval(interval);

      window.originalOpenGokwikSideCart = window.openGokwikSideCart;

      window.openGokwikSideCart = function () {
        if (window.allowGokwikDrawerOpen) {
          return window.originalOpenGokwikSideCart();
        }
        console.log('Auto cart opening blocked');
        return false;
      };
    }

    // safety stop after ~15s so we don't poll forever if init never completes
    if (attempts > 75) {
      clearInterval(interval);
      console.warn('GoKwik SDK did not report ready in time — override not applied.');
    }
  }, 200);
})();

/* ── 2. Allow manual cart icon click ───────────── */
document.addEventListener('click', function (e) {
  const cartBtn =
    e.target.closest('.header__icon--cart') ||
    e.target.closest('.site-header__cart') ||
    e.target.closest('.cart-link') ||
    e.target.closest('[href="/cart"]');
  if (!cartBtn) return;
  window.allowGokwikDrawerOpen = true;
  setTimeout(() => { window.allowGokwikDrawerOpen = false; }, 500);
}, true);

/* ── 3. State ───────────────────────────────────── */
let lastCartItemCount = 0;
let lastCartHash = '';
let cartInstance = null;
let popupTimer = null;
let syncDebounceTimer = null;
let cartWatcherTimeout = null;

/* ── 4. Initial cart state (one fetch on load) ─── */
fetch('/cart.js')
  .then(res => res.json())
  .then(cart => { lastCartItemCount = cart.item_count || 0; });

/* ── 5. Debounced sync — prevents fetch storms ─── */
function debouncedSync(delay = 100) {
  clearTimeout(syncDebounceTimer);
  syncDebounceTimer = setTimeout(syncProductCardsWithCart, delay);
}

/* ── 6. Cart watcher — runs only after ATC ──────── */
function startCartWatcher() {
  clearInterval(cartWatcherTimeout);

  let elapsed = 0;
  cartWatcherTimeout = setInterval(async () => {
    elapsed += 800;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      if (cart.item_count !== lastCartItemCount) {

        if (cart.item_count > lastCartItemCount) {
          showCartPopup();
        }

        window.currentCartCount = cart.item_count;
        document.dispatchEvent(new CustomEvent('cart:count:update', {
          detail: { count: cart.item_count }
        }));

        lastCartItemCount = cart.item_count;

        // Sync immediately when count changes
        syncProductCardsWithCart();
      }
    } catch (e) {}

    if (elapsed >= 8000) clearInterval(cartWatcherTimeout);
  }, 800);
}

/* ── 7. Add to Cart ─────────────────────────────── */
function add_to_cart_grid(variantid, qty = 1, event = null) {
  window.internalCartAction = true;
  if (event) event.preventDefault();

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { quantity: qty, id: variantid },
    dataType: 'json',

    success: function (data) {
      try {
        cartInstance = new theme.CartDrawer();
        cartInstance.init();
      } catch (err) {}

      showCartPopup(data.product_title);

      window.currentCartCount = (window.currentCartCount || 0) + qty;
      lastCartItemCount = window.currentCartCount;

      document.dispatchEvent(new CustomEvent('cart:count:update', {
        detail: { count: window.currentCartCount }
      }));

      // Optimistically update UI instantly — no fetch wait
      // updateProductCardQty(variantid, qty);

      // Then verify with real cart data
      debouncedSync(100);

      startCartWatcher();
    },

    error: function () {
      window.internalCartAction = false;
    },

    complete: function () {
      setTimeout(() => { window.internalCartAction = false; }, 1500);
    }
  });
}

/* ── 8. Update Quantity ─────────────────────────── */
function updateCartQuantity(variantId, quantity) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: variantId, quantity: quantity },
    dataType: 'json',
    success: function () {
      try {
        cartInstance = new theme.CartDrawer();
        cartInstance.init();
      } catch (err) {}
      // Optimistic update then verify
      updateProductCardQty(variantId, quantity);
      debouncedSync(300);
    }
  });
}

/* ── 9. Update single product card ─────────────── */
/* ── 9. Update ALL matching product cards ───────── */
function updateProductCardQty(variantId, qty) {

  const wrappers = document.querySelectorAll(
    `.product-card-cart[data-variant-id="${variantId}"]`
  );

  if (!wrappers.length) return;

  wrappers.forEach(wrapper => {

    const addBtn   = wrapper.querySelector('.product-card__add-to-cart');
    const qtyBox   = wrapper.querySelector('.qty-box');
    const qtyCount = wrapper.querySelector('.qty-count');

    if (!addBtn || !qtyBox || !qtyCount) return;

    if (qty > 0) {

      addBtn.style.display = 'none';

      qtyBox.classList.add('active');

      qtyCount.textContent = qty;

    } else {

      addBtn.style.display = 'block';

      qtyBox.classList.remove('active');

      qtyCount.textContent = 0;
    }

  });
}

/* ── 10. Sync all product cards ─────────────────── */
/* ── 10. Sync all product cards ─────────────────── */
/* ── 10. Sync all product cards ─────────────────── */

async function syncProductCardsWithCart(force = false) {

  try {

    const res = await fetch('/cart.js?t=' + Date.now(), {
      cache: 'no-store'
    });

    const cart = await res.json();

    const newHash = JSON.stringify(
      cart.items.map(item => ({
        id: item.variant_id,
        qty: item.quantity
      }))
    );

    // Skip only if not forced
    if (!force && newHash === lastCartHash) {
      return;
    }

    lastCartHash = newHash;

    // reset ALL cards
    document.querySelectorAll('.product-card-cart').forEach(card => {

      const addBtn = card.querySelector('.product-card__add-to-cart');
      const qtyBox = card.querySelector('.qty-box');
      const qtyCount = card.querySelector('.qty-count');

      if (addBtn) {
        addBtn.style.display = 'block';
      }

      if (qtyBox) {
        qtyBox.classList.remove('active');
      }

      if (qtyCount) {
        qtyCount.textContent = '0';
      }

    });

    // apply cart quantities
    // combine quantities of split line items

    console.log(
  'Cart Items:',
  cart.items.map(item => ({
    variant: item.variant_id,
    qty: item.quantity,
    key: item.key
  }))
);
const variantTotals = {};

cart.items.forEach(item => {
  variantTotals[item.variant_id] =
    (variantTotals[item.variant_id] || 0) + item.quantity;
});

// apply total quantity to cards
Object.entries(variantTotals).forEach(([variantId, totalQty]) => {

  const wrappers = document.querySelectorAll(
    `.product-card-cart[data-variant-id="${variantId}"]`
  );

  wrappers.forEach(wrapper => {

    const addBtn = wrapper.querySelector('.product-card__add-to-cart');
    const qtyBox = wrapper.querySelector('.qty-box');
    const qtyCount = wrapper.querySelector('.qty-count');

    if (!addBtn || !qtyBox || !qtyCount) return;

    addBtn.style.display = 'none';
    qtyBox.classList.add('active');
    qtyCount.textContent = totalQty;

  });

});

    window.currentCartCount = cart.item_count;
    lastCartItemCount = cart.item_count;

  } catch (e) {

    console.log('Cart sync failed', e);

  }
}

/* ── 11. Popup ──────────────────────────────────── */
function showCartPopup(productTitle = 'Product added') {
  const existing = document.getElementById('cart-popup');
  if (existing) existing.remove();

  const popup = document.createElement('div');
  popup.id = 'cart-popup';
  popup.className = 'cart-popup';
  popup.innerHTML = `
    <span>Product Added To Cart</span>
    <button id="view-cart-btn" type="button">View Cart</button>
  `;
  document.body.appendChild(popup);

  // Force reflow so transition plays
  popup.getBoundingClientRect();
  popup.classList.add('show');

  clearTimeout(popupTimer);
  popupTimer = setTimeout(() => {
    popup.classList.remove('show');
    setTimeout(() => popup.remove(), 300);
  }, 2000);
}

/* ── 12. Open Cart Drawer (with instant sync) ───── */
function openCartDrawer() {
  document.getElementById('cart-popup')?.remove();

  window.allowGokwikDrawerOpen = true;

  if (typeof window.originalOpenGokwikSideCart === 'function') {
    window.originalOpenGokwikSideCart();
  } else if (typeof window.openGokwikSideCart === 'function') {
    window.openGokwikSideCart();
  }

  // Refresh cart data immediately when drawer opens
  syncProductCardsWithCart();

  setTimeout(() => { window.allowGokwikDrawerOpen = false; }, 500);
}

/* ── 13. DOM Events ─────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  syncProductCardsWithCart();

  /* Add to Cart */
  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('.product-card__add-to-cart');
    if (!addBtn) return;
    e.preventDefault();
    e.stopPropagation();
    const wrapper = addBtn.closest('.product-card-cart');
    const variantId = wrapper.getAttribute('data-variant-id');
    add_to_cart_grid(variantId, 1, e);
  });

  /* Plus */
  // document.addEventListener('click', function (e) {
  //   const plusBtn = e.target.closest('.qty-plus');
  //   if (!plusBtn) return;
  //   e.preventDefault();
  //   e.stopPropagation();
  //   const wrapper = plusBtn.closest('.product-card-cart');
  //   const variantId = wrapper.getAttribute('data-variant-id');
  //   const qty = parseInt(wrapper.querySelector('.qty-count').textContent);
  //   updateCartQuantity(variantId, qty + 1);
  // });
  /* Plus */
document.addEventListener('click', function (e) {
  const plusBtn = e.target.closest('.qty-plus');
  if (!plusBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const wrapper = plusBtn.closest('.product-card-cart');
  const variantId = wrapper.getAttribute('data-variant-id');

  add_to_cart_grid(variantId, 1);
});

/* Minus */
document.addEventListener('click', async function (e) {

  const minusBtn = e.target.closest('.qty-minus');
  if (!minusBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const wrapper = minusBtn.closest('.product-card-cart');
  const variantId = Number(
    wrapper.getAttribute('data-variant-id')
  );

  const cart = await fetch('/cart.js').then(r => r.json());

  const matchingItems = cart.items.filter(
    item => item.variant_id === variantId
  );

  if (!matchingItems.length) return;

  // reduce regular line first
  matchingItems.sort((a, b) => a.quantity - b.quantity);

  const itemToReduce = matchingItems[0];

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: itemToReduce.key,
      quantity: itemToReduce.quantity - 1
    })
  });

  syncProductCardsWithCart(true);

});

  /* Block qty-box link bubbling */
  document.addEventListener('click', function (e) {
    const qtyBox = e.target.closest('.qty-box');
    if (!qtyBox) return;
    e.preventDefault();
    e.stopPropagation();
  });

  /* View Cart button */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('#view-cart-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    openCartDrawer();
  });
});

/* ── 14. Optional external events ──────────────── */
document.addEventListener('cart:refresh',    () => debouncedSync(100));
document.addEventListener('cart_updated',    () => debouncedSync(100));
document.addEventListener('drawer_updated',  () => debouncedSync(100));

/* ── 15. GoKwik drawer open event — refresh instantly */
/* ── 15. GoKwik drawer sync watcher ───────────────── */

let gokwikCartWatcher = null;

function startGokwikCartSync() {

  clearInterval(gokwikCartWatcher);

  let previousHash = '';

  gokwikCartWatcher = setInterval(async () => {

    try {

      const res = await fetch('/cart.js');
      const cart = await res.json();

      const currentHash = JSON.stringify(
        cart.items.map(item => ({
          id: item.variant_id,
          qty: item.quantity
        }))
      );

      // detect any cart change
      if (currentHash !== previousHash) {

        previousHash = currentHash;

        window.currentCartCount = cart.item_count;
        lastCartItemCount = cart.item_count;

        document.dispatchEvent(
          new CustomEvent('cart:count:update', {
            detail: { count: cart.item_count }
          })
        );

        // update outside product cards
        syncProductCardsWithCart();
      }

    } catch (e) {}

  }, 700);
}

/* Start watcher when drawer opens */
document.addEventListener('gokwik:drawer:open', () => {
  syncProductCardsWithCart();
  startGokwikCartSync();
});

/* Optional: stop watcher when drawer closes */
document.addEventListener('gokwik:drawer:close', () => {
  clearInterval(gokwikCartWatcher);
});

/* ── 16. PDP Add to Cart (GoKwik native button) ─── */
document.addEventListener('click', function (e) {
  const pdpBtn = e.target.closest('.gk-pdp-atc');
  if (!pdpBtn) return;

  window.allowGokwikDrawerOpen = true;

  setTimeout(() => { showCartPopup(); }, 300);

  setTimeout(async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      window.currentCartCount = cart.item_count;
      lastCartItemCount = cart.item_count;

      document.dispatchEvent(new CustomEvent('cart:count:update', {
        detail: { count: cart.item_count }
      }));

      syncProductCardsWithCart();
    } catch (e) {}
  }, 600); // slightly faster than original 1000ms

  setTimeout(() => { window.allowGokwikDrawerOpen = false; }, 2000);
}, true);

/* ── 17. Continuous cart sync ───────────────────── */

// setInterval(() => {

//   syncProductCardsWithCart(true);

// }, 1500);